var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82in",
    height: "44in",
    clipRule: "evenodd",
    fillRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 82 44",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h82v44H0z",
    fill: "#c62139"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2h78v40H2z",
    fill: "#00297b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.024 10.662s-7.583 5.525-7.583 11.264c0 5.74 7.583 11.412 7.583 11.412s7.535-5.258 7.535-11.412c0-6.152-7.535-11.264-7.535-11.264z",
    fill: "#92dbfc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.28 25.43c1.974 4.34 6.744 7.908 6.744 7.908s4.856-3.389 6.77-7.909",
    fill: "#008ce7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.821 24.177c-1.169.766-7.747.398-7.747.398l-.368.858 7.833.022c.032-.118.11-.258.138-.376z",
    fill: "#9c8431",
    style: {
      fill: "#ccc"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.051 27.726c.333.01.665.075.963.22.533.257.841.255 1.415.263.601.008 1.073.413 1.722.43 1.196.03 1.7.575.77.575-.44 0-1.382-.27-1.837-.214-.692.064-1.092.112-1.604.485a19.481 19.481 0 0 1-1.429-1.759zm2.367 2.731c.296-.185.5-.33.788-.339.56-.015.75-.332 1.397-.332.735.123 1.73-.08 2.314-.2 1.034-.218.544-.88-.083-1.121-.506-.199-1.455-.01-2.044-.207-.445-.16-.078-.413.162-.467.241-.041.5.032.802.077a8.401 8.401 0 0 0 1.684-.07c.975-.137.935-.399 1.406-.405.343-.014.605-.108.84-.261.274-.168.561-.513.894-.5l.196.008c-2.057 3.644-5.751 6.036-5.751 6.036s-1.194-.837-2.605-2.219z",
    fill: "#ffde52"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.875 23.883c.028-.038.056-.021.084 0l.06 2.786h-.2z",
    style: {
      fill: "#8c4200"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.45 26.575s2.525.176 4.074-.128c0 0 .13.08-.056.28-.187.2-.66.243-.92.286 0 0-.063.128-.058.195.006.067.164.06.242.045l.078-.014s-.037.25-.993.283c-.314.011-1.348.031-1.567-.25 0 0 .19.014.239 0 .05-.014.013-.195-.005-.221-.018-.026-.67 0-1.014-.29-.085-.083-.125-.172-.125-.203 0-.003.104.017.104.017zm1.316.485s.691.081 1.486 0c0 0 .021.138-.015.19-.036.053-.954.093-1.417.02-.074-.022-.077-.105-.054-.21z",
    fill: "#8c4200"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.908 26.386s.8-1.004.543-2.74c1.237.688 2.288 1.725 2.574 2.688-1.122-.26-2.113-.08-3.117.052z",
    fill: "#fdf9ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.026 10S33 15.471 33 21.922C33 28.374 41.026 34 41.026 34S49 28.838 49 21.922C49 15.007 41.026 10 41.026 10zm-.003 1.324s-7.14 4.867-7.14 10.607c0 5.74 7.14 10.745 7.14 10.745s7.094-4.592 7.094-10.745-7.094-10.607-7.094-10.607z",
    fill: "#c62139"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.146 27.788c.128.452.263.606.782.722.512.116 1.294-.34.81-.782-.462-.412-.948-.517-1.362-.888-.641-.582-1.521-1.786-1.939-2.924-.457-1.245-.378-4.748-.357-6.523 0-.02.055-.033.062-.041.03-.04.058.012.011-.248-.012-.067-.07-.136-.07-.203.001-.12-.453.131-.572.346-.028.049.087.189.087.216.015 1.703-.185 5.065.309 6.587.305.942.863 1.67 1.367 2.343.303.431.74.897.872 1.395z",
    fill: "#8c4200",
    style: {
      strokeWidth: 0.015625,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.311 16.89c.033.04.028.216.028.216.026.014.454-.334.454-.318 0 .073.01.224.01.224s.443-.385.461-.345c.02.046-.002.27-.002.27l.349-.352c.039-.038.033.049.036.188.001.025.483-.325.512-.331.063-.013.082.182.079.23-.003.036.445-.233.425-.198l.033.207c.125-.015.422-.117.6-.09.058.008.055.034.004.054-.861.319-1.524.8-1.91 1.47-.131.229-.171.428-.136.478 0 0 .154-.305.329-.353.023-.006.039.196.063.184 0 0 .132-.305.227-.418.026-.03.068.16.096.132 0 0 .068-.204.203-.347.019-.02.054.194.075.176.14-.118.27-.413.322-.435.037-.026.043.245.078.222 0 0 .199-.366.317-.432.077-.043.074.2.074.2.151-.137.318-.364.397-.462.037-.046.017.298.055.312.05.017.377-.264.413-.27.025-.003.053.08-.01.148l-.404.426c.078.014.108-.006.163.007.166.04-.31.29-.301.336 0 0 .229-.004.152.037-.055.03-.358.386-.358.373 0-.006.152.003.151.043-.001.074-.251.455-.254.453-.013-.012.135-.016.155.021.037.07-.257.378-.2.43.008.008.168.003.239.017.034.007.13.56.106.538a4.833 4.833 0 0 1 .169-.675c.04-.094.169.143.179.122-.005 0-.026-.337-.008-.491.005-.043.098.045.096.004-.003-.093-.011-.193.01-.284.015-.068.094.124.125.072 0 0-.096-.334-.056-.428.026-.062.09.15.132.158 0 0-.024-.26.02-.326l.133.13c.029-.042.023-.447.05-.484.022-.032.16.151.18.123.019-.027-.058-.327-.04-.35.024-.035.175.083.178.08.061-.056.06-.198.085-.25.07-.142.468-.16.515-.06.023.05.007.113-.002.19.003.002.2.015.2.001 0 0-.023.168-.009.352.002.025.199-.006.202.019.017.173-.026.19-.026.19.002.012.133-.02.135-.006a.448.448 0 0 1-.074.287c-.01.014.187-.014.19.003.024.13.028.234.004.418-.002.014.192-.13.195-.115.03.154-.005.321.013.482.004.037.128-.111.14-.068.01.042-.028.348-.01.366 0 0 .209-.01.227.006.165.142.134.39.134.39.045-.031.028-.33-.018-.602-.005-.029.16-.018.155-.045 0 0-.18-.1-.24-.377-.013-.059.174-.047.174-.047-.052-.109-.143-.13-.22-.235-.025-.034.194-.05.194-.06 0-.104-.185-.154-.281-.263-.041-.046.2-.049.2-.049-.07-.09-.304-.13-.423-.248-.064-.065.237-.129.233-.14-.033-.095-.316-.125-.454-.233-.028-.022.18-.097.18-.097-.021-.04-.474-.313-.244-.288.098.01.295.137.31.118 0 0-.008-.16.012-.178.076-.072.337.305.425.29 0 0 .033-.27.073-.278.096-.016.212.394.306.394.013 0 .02-.237.068-.25.055-.015.117.266.186.328.064.057.065-.22.103-.167.064.085.08.262.167.34.057.05.067-.244.13-.205.074.046.057.198.139.273.04.036.066-.194.11-.16.04.03.067.31.11.355.054.057.117-.148.173-.116.04.024.031.267.069.32.077.108.117-.131.168-.094.036.025.113.304.145.326.071.05.11-.127.165-.102.04.018.119.378.152.369.02-.006.074-.821-.269-1.165-.557-.56-1.556-.883-2.371-.891 0 0 .41-.075.42-.137.022-.124.225-.11.367-.08.025.004.012-.22.015-.22.127-.004.24.065.362.132.037.022-.077-.224-.037-.203.156.083.33.107.434.207.028.026-.031-.189-.031-.189.077-.017.23.085.291.182.03.047-.002-.251.021-.198 0 0 .272.084.3.188 0 0 .023-.189.06-.179.108.026.204.194.289.219 0 0-.036-.169-.008-.163.204.048.426.163.426.163-.115-.264-.552-.54-1.32-.614a4.743 4.743 0 0 0-1.198.068c-.397.084-.71.132-.646.075.262-.236.687-.265.804-.32.083-.039-.282-.168-.21-.186.073-.016.399-.04.399-.04.07-.051-.237-.15-.191-.224.092-.147.636-.013.683-.07.015-.018-.234-.153-.224-.173.04-.074.524.056.536-.01 0 0-.147-.1-.252-.182-.012-.01.433-.12.433-.12a.733.733 0 0 0-.178-.088c-.094-.033.39-.148.39-.148-.613-.257-2.205.473-2.521 1.231-.082.181-.085-.016-.067-.169.016-.165.039-.31.02-.46-.007-.045-.13.119-.14.075-.031-.16.063-.337.02-.516-.014-.06-.179.177-.2.117-.061-.165.044-.397.002-.625-.017-.089-.173.19-.225.111-.061-.092-.035-.434-.064-.486-.023-.042-.162.164-.174.125-.188-.627.062-.705-.3-.352-.012.013-.092-.37-.106-.358-.148.29-.39-.206-.474-.16-.062.035.17.228.172.314.001.042-.213.045-.213.045.005.071.407.272.42.35.01.065-.284.05-.284.05.009.087.344.17.362.264.01.05-.157.062-.151.115.009.08.324.238.334.32.007.056-.201.08-.206.132-.006.064.418.279.419.34 0 .084-.17.04-.246.083-.109.06.347.304.367.374.015.06-.183.007-.19.062-.008.073.224.183.277.308.053.123-.001.155-.077.106-.153-.099-.769-.698-.933-.858a1.982 1.982 0 0 0-1.21-.507c-.05.014.262.216.264.289 0 .019-.14.047-.134.052.086.08.355.173.355.173l-.077.127c.018.037.145.047.348.109 0 0-.152.086-.14.094.107.08.316.137.316.137l-.206.064c-.012.036.464.21.464.21s-.149.118-.142.124c.036.033.385.107.385.107.006.005-.246.077-.245.079.092.084.345.111.404.25 0 0 .034.079-.066.064-.393-.131-1.002-.401-2.183-.295-1.208.144-2.128 1.105-2.112 1.2 0 0 .432-.283.477-.225z",
    fill: "#109421",
    style: {
      strokeWidth: 0.015625,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.631,
    cy: 16.881,
    r: 0.286,
    style: {
      fill: "#8c4200",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 33,
      strokeWidth: 0.015625,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.605,
    cy: 17.35,
    r: 0.286,
    style: {
      fill: "#8c4200",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 33,
      strokeWidth: 0.015625,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.998,
    cy: 16.774,
    r: 0.286,
    style: {
      fill: "#8c4200",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 33,
      strokeWidth: 0.015625,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.041,
    cy: 17.172,
    r: 0.286,
    style: {
      fill: "#8c4200",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 33,
      strokeWidth: 0.015625,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.59 22.169q-.02 0-.027.017-.007.015-.01.041h-.03v-.41h.03q.005.053.037.053h.728v.035q-.04.003-.04.05v.486q0 .02.005.035t.025.015h.012v.035q-.335.21-.794.21-.155 0-.3-.043-.144-.047-.255-.144-.11-.096-.18-.243-.066-.15-.066-.348t.066-.346q.07-.149.18-.246.111-.1.254-.146.146-.05.301-.05.062 0 .109.003.046.003.09.012.045.009.092.023.047.012.111.033.062.02.114.05.051.026.066.026.02 0 .035-.024l.03.012-.161.386-.03-.02q.005-.018.005-.032 0-.02-.042-.044-.042-.027-.106-.047t-.145-.035q-.08-.015-.156-.015-.088 0-.17.03-.079.026-.143.084-.061.059-.098.147-.037.085-.037.205 0 .117.044.205.044.085.111.14.069.056.153.082.084.026.165.026.104 0 .185-.014.084-.015.16-.041v-.193z",
    style: {
      fill: "#bd0728",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 33,
      strokeWidth: 0.0251908
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.886 21.26q0-.022-.012-.033-.009-.015-.053-.021v-.036h.478v.036q-.044.006-.055.02-.01.012-.01.033v.794q0 .195-.05.328-.05.134-.138.213-.086.08-.204.113-.116.03-.249.03-.132 0-.25-.03-.117-.033-.205-.113-.086-.08-.137-.213-.049-.133-.049-.328v-.794q0-.02-.011-.032-.01-.015-.054-.021v-.036h.479v.036q-.044.006-.056.02-.01.012-.01.033v.794q0 .171.077.245.077.074.216.074.14 0 .216-.074t.077-.245z",
    style: {
      fill: "#bd0728",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 33,
      strokeWidth: 0.0245843
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.734 22.671q0 .015.008.024.01.006.04.006v.036h-.468V22.7q.03-.006.042-.018.014-.015.027-.05l.026-.081q.021-.065.056-.164l.076-.223.085-.247.082-.247.074-.218q.032-.095.05-.155l.021-.062q0-.015-.018-.021-.016-.006-.035-.009v-.036h.69v.036q-.02.003-.034.009-.013.006-.013.03 0 .006.023.077.027.072.067.188l.09.259.108.295.106.291.095.257q.02.053.034.071.016.018.04.018v.036h-.521V22.7q.05-.003.05-.036l-.013-.039-.03-.083-.03-.09q-.014-.04-.017-.056h-.626q-.027.08-.042.131l-.027.08-.013.045-.003.018zm.643-.512-.257-.709-.235.709z",
    style: {
      fill: "#bd0728",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 33,
      strokeWidth: 0.0263019
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.831 22.712q.048-.006.059-.017.012-.015.012-.036v-1.096l-.005-.006-.453 1.155-.447-1.167h-.005v1.114q0 .02.01.036.013.011.061.017v.036h-.448v-.036q.049-.006.059-.017.013-.015.013-.036V21.27q0-.02-.013-.033-.01-.014-.059-.02v-.036h.664v.036q-.06.003-.06.053l.014.048.039.11.053.143q.03.074.056.146.028.068.048.122t.028.071q.043-.113.09-.22t.08-.196q.039-.09.062-.15.022-.059.022-.074 0-.05-.06-.053v-.036h.689v.036q-.049.006-.061.02-.01.012-.01.033v1.388q0 .02.01.036.012.011.06.017v.036h-.508z",
    style: {
      fill: "#bd0728",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 33,
      strokeWidth: 0.0257989
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGu);
export default __webpack_public_path__ + "static/media/gu.3d4aeecd4cdd2388dd2f02246c15b360.svg";
export { ForwardRef as ReactComponent };